import StrukturOrganisasiContent from "../../components/layouts/tentang/StrukturOrganisasiContent";

import React from "react";

const StrukturOrganisasi: React.FC = () => {
  return (
    <div>
      <StrukturOrganisasiContent />
    </div>
  );
};

export default StrukturOrganisasi;
